module.exports = __webpack_public_path__ + "img/acc11.a9a6d1ed.png";